import { useTranslation } from 'react-i18next';
import "../styles/cta_section/cta_section.css";
import { useNavigate, useParams } from 'react-router-dom';
export default function CTASection() {
    const navigate = useNavigate();
    const { lang } = useParams();
    const { t } = useTranslation();
    return (
        <div className="cta_section">
            <div className="container">
                <div className="contain">
                    <div className="head_text">
                        <div className="head">
                            <h1>{t('cta-title')}</h1>
                        </div>

                        <p> {t('cta-description')}</p>
                    </div>
                    <div className="upload">
                        <button onClick={() => navigate(`/lang/${lang}/login`)}>{t('cta-button')}</button>
                    </div>
                </div>
            </div>
        </div >
    );
}